import HelpContactInfo from './components/HelpContactInfo';

export default HelpContactInfo;



// WEBPACK FOOTER //
// ./src/routes/HelpContactInfo/index.js